import { render, staticRenderFns } from "./IndexPageBackToTopSection.vue?vue&type=template&id=207d11db&scoped=true&"
import script from "./IndexPageBackToTopSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageBackToTopSection.vue?vue&type=script&lang=js&"
import style0 from "./IndexPageBackToTopSection.vue?vue&type=style&index=0&id=207d11db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d11db",
  null
  
)

export default component.exports